import React from "react";
import PropTypes from "prop-types";
import { handleEnterSpaceKey } from "utils";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/MatrixQuestionRow.scss';

const MatrixQuestionRow = ({ rowId, row, onOptionSelected, isDisabled }) => {
  const { text: rowText, options } = row;
  const textId = `${rowId}-text`;

  const handleOnChange = (changedOption) => {
    if (isDisabled) {
      return;
    }
    return onOptionSelected(changedOption, row);
  };

  const handleOnKeyUp = (event, changedOption) => {
    if (isDisabled) {
      return;
    }
    return handleEnterSpaceKey(event, () => onOptionSelected(changedOption, row));
  };

  return (
    <div className="csw-q-mtrx-row" id={rowId}>
      <ul className="csw-q-mtrx-o-list csw-option-list" role="radiogroup" aria-labelledby={textId}>
        <li className="csw-q-mtrx-o" role="heading" aria-level="2" id={textId}>
          {rowText}
        </li>

        {options &&
          options.map((optionDetail, index) => {
            const { id, text, selected } = optionDetail;
            const mtrxOptId = `csw-q-o-${rowId}-${id}`;
            const mtrxKey = `${mtrxOptId}-${index}`;

            return (
              <li className="csw-q-mtrx-o" key={mtrxKey} aria-labelledby={`${mtrxOptId}-lbl`}>
                <input
                  className="csw-q-mtrx-rdo-input sr-only outline-trigger"
                  type="radio"
                  id={mtrxOptId}
                  name={rowId}
                  value={text}
                  defaultChecked={selected}
                  onChange={() => handleOnChange(optionDetail)}
                  aria-label={text}
                  aria-describedby={textId}
                  disabled={isDisabled}
                  onKeyUp={(event) => handleOnKeyUp(event, optionDetail)}
                  tabIndex="-1"
                />
                <label
                  className="csw-q-mtrx-lbl outline"
                  id={`${mtrxOptId}-lbl`}
                  htmlFor={mtrxOptId}
                  onKeyUp={(event) => handleOnKeyUp(event, optionDetail)}
                  tabIndex="0"
                  aria-label={`${text} ${rowText}`}
                  aria-describedby={textId}
                  role="radio"
                  aria-checked={selected}
                  aria-disabled={isDisabled}
                >
                  <span className="csw-q-mtrx-chk csw-option-check-border" aria-hidden="true">
                    {" "}
                  </span>
                </label>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

MatrixQuestionRow.propTypes /* remove-proptypes */ = {
  rowId: PropTypes.string.isRequired,
  row: PropTypes.object,
  onOptionSelected: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default MatrixQuestionRow;
